import React, { useState, useEffect } from "react";
import style from "./CheckBox.module.css";

function Checkbox(props) {
	const isControlled = typeof props.isChecked === 'boolean';
	const [internalChecked, setInternalChecked] = useState(!!props.isChecked);

	// Sync internal state when used as a controlled component
	useEffect(() => {
		if (isControlled) {
			setInternalChecked(!!props.isChecked);
		}
	}, [props.isChecked, isControlled]);

	function handleCheckboxClick() {
		const current = isControlled ? internalChecked : internalChecked;
		const newValue = !current;
		if (!isControlled) setInternalChecked(newValue);
		props.onChange && props.onChange(newValue);
		props.onCheckboxChange && props.onCheckboxChange(newValue);
	}


	return (
		<div className={`${style.checkbox} ${internalChecked ? style.checked : ""}`} onClick={handleCheckboxClick}>
			<div className={style.checkboxBox}>
				<span className={style.checkboxLabel}>{props.label}</span>
			</div>
			<input
				type="checkbox"
				checked={internalChecked}
				onChange={handleCheckboxClick}
				style={{ display: 'none' }}
			/>
		</div>
	);
}

export default Checkbox;
